export default "__VITE_ASSET__33cab289__"